import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
 

import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod
 const GetRequestData=(params:any)=>request({
  url: ApiURL.Query.GetRequestData,
  method: RequestType.GET,
  params:params
 });

 const AddRequestData=(data:any)=>request({
  url: ApiURL.Command.AddRequestData,
  method: RequestType.POST,
  data
 });
 const UpdateRequestData=(data:any)=>request({
  url: ApiURL.Command.UpdateRequestData,
  method: RequestType.PUT,
  data
 });

 
 const DeleteRequestData = (returnId:number) => request({
  url: ApiURL.Command.DeleteRequestData + "/" + returnId,
  method: RequestType.DELETE,
});

 
 
const CompleteAndConfirmQuery = {
  GetRequestData,
  AddRequestData,
  UpdateRequestData,
  DeleteRequestData

};

export default CompleteAndConfirmQuery;